<template>
	<div class="quest-selector">
		<select v-model="selectedQuestId">
			<option v-for="[id] in questList" :key="id" :value="id">
				{{ id }}
			</option>
		</select>
		<button @click="assignQuest">Prideliť quest</button>
		<button @click="resetQuests">Reset</button>

		<div v-if="activeMainQuest" class="active-quest">
			<h2>{{ mainQuestConfig?.title }}</h2>
			<p>
				Progress: {{ activeMainQuest.progress }} /
				{{ mainQuestConfig?.objective.amount }}
			</p>
		</div>
	</div>
</template>

<script lang="ts" setup>
import { QuestTypes } from "@/game/entities/config/quests/quest_types.js";
import { quests } from "@/game/entities/config/quests/quests";
import router from "@/router";
import useQuestStore from "@/store/useQuestStore";
import type { QuestActive, QuestItem } from "@/types/quest";
import { RouteNames } from "@/types/ui";
import { computed, onMounted, ref } from "vue";

const questStore = useQuestStore();

const selectedQuestId = ref<number | null>(null);

// Konvertujeme Map na Array pre iteráciu
const questList = computed(
	(): Array<[number, QuestItem]> => Array.from(quests.entries()),
);

// Získa aktuálny MAIN quest, ak existuje
const activeMainQuest = computed(
	(): QuestActive | null =>
		questStore.getActiveQuests.find(
			(q: QuestActive): boolean => q.type === QuestTypes.MAIN,
		) || null,
);

const mainQuestConfig = computed((): QuestItem | null => {
	if (!activeMainQuest.value) return null;
	return quests.get(activeMainQuest.value.id) || null;
});

// Nastavíme prvý quest ako defaultný po načítaní komponentu
onMounted((): void => {
	if (questList.value.length > 0)
		selectedQuestId.value = questList.value[0][0];
});

const resetQuests = (): void => {
	questStore.resetQuests();
};

const assignQuest = (): void => {
	if (selectedQuestId.value !== null) {
		const quest = quests.get(+selectedQuestId.value);
		if (quest) {
			questStore.addQuest(+selectedQuestId.value, 0);
			router.push({
				name: RouteNames.QUESTS,
				params: {
					questPopupId: selectedQuestId.value,
				},
			});
		} else {
			console.error("Chyba: Quest s daným ID neexistuje.");
		}
	}
};
</script>

<style scoped>
.quest-selector {
	display: flex;
	flex-direction: column;
	gap: 10px;
	border-radius: 5px;
	background: rgba(255, 255, 255, 0.9);
	padding: 10px;
}

.active-quest {
	margin-top: 10px;
	border: 1px solid #ccc;
	border-radius: 5px;
	background: rgba(255, 255, 255, 0.95);
	padding: 10px;
}
</style>
